/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9zcmMvYXBwL2FnYXRleHRzY3JlZW5zL3BkYS9zaGlwcGluZy9zaGlwLW9yZGVyL3NoaXAtb3JkZXIuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9zcmMvYXBwL2FnYXRleHRzY3JlZW5zL3BkYS9zaGlwcGluZy9zaGlwLW9yZGVyL3NoaXAtb3JkZXIuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/app/agatextscreens/pda/shipping/ship-order/ship-order.component.scss.shim.ngstyle.ts